var map = {
	"./andrea.jpg": 98333,
	"./bajram.jpg": 9781,
	"./carlo.jpg": 51627,
	"./davide.jpg": 8133,
	"./emanuele.jpg": 94234,
	"./kristian.jpg": 71302,
	"./lorenzo.jpg": 93258,
	"./marco.jpg": 87909,
	"./michael.jpg": 72240,
	"./romeo.jpg": 33190,
	"./sara-petrocchi.jpg": 56750,
	"./valerio.jpg": 97159,
	"./vishal.jpg": 41623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82021;